export enum LicenseTypeEnum {
  Device = 'Dispositivo',
  Web = 'Web',
}